var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRsu = function SvgIconRsu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M14 4.006H2v5m12-5h16v18h-5m-11-18v5m0 13h-2m2 0v-13m0 13h3v4m-13 0v-4H2v-13m0 0h12"
  })));
};
export { SvgIconRsu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMiAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDQuMDA1ODZIMlY5LjAwNTg2TTE0IDQuMDA1ODZIMzBWMjIuMDA1OUgyNU0xNCA0LjAwNTg2VjkuMDA1ODZNMTQgMjIuMDA1OUgxMk0xNCAyMi4wMDU5VjkuMDA1ODZNMTQgMjIuMDA1OUgxN1YyNi4wMDU5TTQgMjYuMDA1OVYyMi4wMDU5SDJWOS4wMDU4Nk0yIDkuMDA1ODZIMTQiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuOCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";